<template>
    <div class="section-flexible-fees">
        <h5 class="section-flexible-fees__title">Defina a taxa dos seus presentes e o tempo de recebimento:</h5>
        <div class="credit-card-fee">
            <span class="credit-card-fee__title">Cartão de crédito</span>
            <div class="credit-card-fee__items">
                <FeeCard :isRecommended="false" :id="creditCardFees[0].id" :fee="creditCardFees[0].fee"
                    :days="creditCardFees[0].days" :isSelected="creditCardFeeSelected === creditCardFees[0].id"
                    @select="$emit('select-fee', creditCardFees[0].id)" />
                <FeeCard :isRecommended="true" :id="creditCardFees[1].id" :fee="creditCardFees[1].fee"
                    :days="creditCardFees[1].days" :isSelected="creditCardFeeSelected === creditCardFees[1].id"
                    @select="$emit('select-fee', creditCardFees[1].id)" />
                <FeeCard :isRecommended="false" :id="creditCardFees[2].id" :fee="creditCardFees[2].fee"
                    :days="creditCardFees[2].days" :isSelected="creditCardFeeSelected === creditCardFees[2].id"
                    @select="$emit('select-fee', creditCardFees[2].id)" />
            </div>
        </div>
        <div class="pix-fee">
            <span class="pix-fee__title">Pix e boleto</span>
            <div class="pix-fee__banner">
                <div class="pix-fee__banner__tax-data">
                    <span>Taxa de {{ pixFee }}%</span>
                    <p>Recebimento em {{ pixRepassDeadline }} dias úteis</p>
                </div>
                <hr />
                <div class="pix-fee__banner__info">
                    <span class="material-symbols-rounded">info</span>
                    <p>Para compras no cartão de crédito, as taxas da lista de presente variam conforme o prazo de
                        recebimento. No Pix e Boleto, a taxa é única e o recebimento é mais rápido.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeeCard from './FeeCard.vue';

export default {
    name: 'FlexibleFeesInterface',

    props: {
        creditCardFees: {
            type: Array,
            required: true
        },
        creditCardFeeSelected: {
            type: String,
            required: true
        },
        pixFee: {
            type: Number,
            required: true
        },
        pixRepassDeadline: {
            type: Number,
            required: true,
            default: 2
        }
    },

    components: {
        FeeCard
    }
}
</script>

<style lang="scss" scoped>
.section-flexible-fees {
    padding-top: 24px;

    @media (max-width: 929px) {
        padding-top: 0px;
    }

    &__title {
        color: #374455;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 20px;

        @media (max-width: 929px) {
            margin-bottom: 25px;
        }
    }
}

.credit-card-fee {
    width: 100%;
    display: flex;
    gap: 12px;
    flex-direction: column;
    margin-bottom: 12px;

    @media (max-width: 929px) {
        gap: 17px;
        margin-bottom: 25px;
    }

    &__title {
        color: #374455;
        font-size: 16px;
    }

    &__items {
        display: flex;
        flex-direction: row;
        gap: 8px;

        @media (max-width: 929px) {
            flex-direction: column;
        }
    }
}

.pix-fee {
    width: 100%;
    display: flex;
    gap: 12px;
    flex-direction: column;

    &__title {
        color: #374455;
        font-size: 16px;
    }

    &__banner {
        width: 100%;
        padding: 16px 24px;
        display: flex;
        flex-direction: row;
        background-color: #F6F7F9;
        border-radius: 8px;

        @media (max-width: 929px) {
            flex-direction: column;
        }

        &__tax-data {
            display: flex;
            flex-direction: column;
            gap: 12px;
            justify-content: center;

            span {
                color: #4E637B;
                font-size: 16px;
                font-weight: 700;
            }

            p {
                color: #5D758D;
                font-size: 14px;
                white-space: nowrap;
            }
        }

        &__info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 12px;

            span {
                width: 24px;
                height: 24px;
            }

            p {
                color: #5D758D;
                font-size: 14px;
            }
        }
    }
}

hr {
    width: 1px;
    height: 92.5px;
    background-color: #D4DBE3;
    margin: 0 21px;

    @media (max-width: 929px) {
        margin: 21px 0;
        width: 100%;
        height: 1px;
        flex-direction: row;
    }
}
</style>